import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from "react-bootstrap";
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {connect} from 'react-redux';
import { useTranslation } from 'react-i18next';

import {createFolder as actionCreateFolder} from '../../actions/application';
import {createChildFolder, createRootFolder} from '../../services/folder';

export const FolderCreateDialog = ({application, cancel, createFolder, folders}) => {
  const { t } = useTranslation();

  const [nameValue, setNameValue] = useState('');
  const visible = Object.keys(application).includes('createFolderParentId') && application.createFolderParentId !== null;

  useEffect(() => {
    cancel();
  }, []);

  return (
    <Modal
      show={visible}
      onHide={() => {
        cancel();
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="folder-create-modal"
    >
      <Modal.Header>
        <div className="folder-create-modal-header">
          <Modal.Title>
            {t(application.createFolderParentId?.length > 0 &&
              folders.explodedItems[application.createFolderParentId] ?
              'createFolderDialog.title' : 'createFolderDialog.new_folder')
            }
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div id="folderCreate" className="form-group">
          <div className="d-flex justify-content-end mt-3">
            <span className="inter-bold-20 text-required">*</span>
            <span className="inter-regular-14 text-color-grey-600 ml-1">
              {t('general.required_field')}
            </span>
          </div>
          <div className="mb-2 mt-1">
            <div className="e-float-input type-text-input">
              <label className="inter-regular-16 label-field-text">
                {t("createFolderDialog.folderNameLabel")}
                <span className="inter-bold-20 text-required ml-1">*</span>
              </label>
              <TextBoxComponent
                id="name"
                placeholder={t("createFolderDialog.folderNameLabel")}
                change={e => {
                  setNameValue(e.value);
                }}
                input={e => {
                  setNameValue(e.value);
                }}
                className="field-input"
              />

            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end modal-btn-container">
          <button
            type="button"
            className="mr-left font-weight-bold btn-outline-primary btn btn-secondary"
            onClick={cancel}
          >
            {t('general.cancel')}
          </button>
          <button
            type="button"
            className="mr-left font-weight-bold btn-primary btn"
            onClick={() => createFolder(nameValue)}
            disabled={nameValue === ''}
          >
            {t('general.create')}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

FolderCreateDialog.propTypes = {
  application: PropTypes.object,
  cancel: PropTypes.func,
  createFolder: PropTypes.func
};

FolderCreateDialog.defaultProps = {
};

const mapStateToProps = state => ({
  application: state.application,
  folders: state.folders
});

const mapDispatchToProps = dispatch => ({
  cancel: () => dispatch(actionCreateFolder(null)),
  createRootFolder: (user, newFolderName) => createRootFolder(dispatch, user, newFolderName),
  createChildFolder: (user, parentFolder, newFolderName) =>
    createChildFolder(dispatch, user, parentFolder, newFolderName)
});

const mergeProps = (stateProps, dispatchProps, ownProps) => (Object.assign({}, stateProps, dispatchProps, ownProps, {
  createFolder: newFolderName => {
    const folderParentId = stateProps.application.createFolderParentId;
    if (folderParentId.length > 0 && stateProps.folders.explodedItems[folderParentId]) {
      dispatchProps.createChildFolder(
        stateProps.application.user, stateProps.folders.explodedItems[folderParentId], newFolderName);
    } else {
      dispatchProps.createRootFolder(stateProps.application.user, newFolderName);
    }
  }
}));

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(FolderCreateDialog);
